import React, { FC, useMemo } from 'react';
import styles from './PaymentOrderResume.module.scss';
import { IExtract } from '../../../../../modules/consume/domain/models/Extract';
import { moneyMaskNumber } from '../../../../../services/utils/Money';
import { IOrder } from '../../../../../modules/cart/domain/models/IOrder';
import { IOrderItem } from '../../../../../modules/cart/domain/models/IOrderItem';
import { useI18n } from '../../../../../hooks/useI18n';

interface IPaymentOrderResumeProps {
    orderItems: IOrderItem[];
    totalToPay: number;
    discount?: number;
    paidAmount?: number;
}
export const PaymentOrderResume: FC<IPaymentOrderResumeProps> = ({ orderItems, totalToPay, discount, paidAmount }) => {
    const { t } = useI18n();

    var percentDiscount = useMemo(() => {
        if (discount && totalToPay) {
            return (discount / totalToPay) * 100;
        }
        return 0;
    }, [discount, totalToPay]);
    return <div className={styles.orderResume}>
        <b>{t('paymentSummary.orderResume')}</b>

        {
            orderItems.map((item, index) => {
                return <div key={index} className={styles.total}>
                    <label>{item.quantity} - {item.name} ({moneyMaskNumber(item.price)}):</label><span>{moneyMaskNumber(item.price * item.quantity)}</span>
                </div>
            })
        }


        <div className={styles.partial}>

            {discount && <>
                <div className={styles.value}>
                    <label>{t('paymentSummary.total')}</label><span>{moneyMaskNumber(totalToPay)}</span>
                </div>

                <div className={styles.value}>

                    <label>{t('paymentSummary.discountApplied')} ({Number(percentDiscount.toFixed(2))}%):</label>
                    <span>-{moneyMaskNumber(Number(discount?.toFixed(2)))}</span>

                </div>
            </>
            }

            {paidAmount ? 
                <div className={styles.total}>
                    <label>{t('paymentSummary.totalPaid')}</label><span>{moneyMaskNumber(paidAmount)}</span>
                </div> : null
            }
            <div className={styles.value}>
                <label>{t('paymentSummary.amountToPay')}</label><span>{moneyMaskNumber(totalToPay - (discount ?? 0))}</span>
            </div>

            {paidAmount && paidAmount !== totalToPay ?
                <div className={styles.remain}>
                    <label>{t('paymentSummary.remainingAmount')}</label><span>{moneyMaskNumber(totalToPay - paidAmount - (discount ?? 0))}</span>
                </div> : null
            }
        </div>
    </div >;
};
